// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.css
// module id = 62
// module chunks = 0